var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefferalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.6866 8.71131C6.59967 8.70262 6.49534 8.70262 6.39971 8.71131C4.33061 8.64176 2.6875 6.94649 2.6875 4.86C2.6875 2.73005 4.40885 1 6.5475 1C8.67746 1 10.4075 2.73005 10.4075 4.86C10.3988 6.94649 8.7557 8.64176 6.6866 8.71131Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9919 2.73926C14.6785 2.73926 16.0347 4.10417 16.0347 5.78205C16.0347 7.42516 14.7307 8.76399 13.1049 8.82485C13.0354 8.81615 12.9571 8.81615 12.8789 8.82485",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.33963 11.9188C0.23575 13.3272 0.23575 15.6223 2.33963 17.022C4.73039 18.6216 8.65125 18.6216 11.042 17.022C13.1459 15.6136 13.1459 13.3185 11.042 11.9188C8.65995 10.3278 4.73909 10.3278 2.33963 11.9188Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.668 16.6488C15.2939 16.5184 15.8851 16.2663 16.3719 15.8925C17.7282 14.8753 17.7282 13.1974 16.3719 12.1803C15.8938 11.8151 15.3113 11.5717 14.6941 11.4326",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefferalIcon);
export default __webpack_public_path__ + "static/media/refferal_icon.25a5f7dbd797b2f21d025d9e7fff8e79.svg";
export { ForwardRef as ReactComponent };